import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SuccesSnakBarComponent } from "../../../components/succes-snak-bar/succes-snak-bar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "environments/environment";
@Injectable({
  providedIn: "root",
})
export class VehiculeService {
  nomVoiture: string;

  public routeParam: any;

  public pageType: string;

  uri = environment.uriG + ""; 

  constructor(
    private http: HttpClient,
    private route: Router,
    private snackBar: MatSnackBar,
  ) {}

  //API
  addVehicule(data) :any {
    this.snackBar.openFromComponent(SuccesSnakBarComponent, {
      duration: 3000,
    });
    return this.http.post(`${this.uri}/api/vehicles`, data);
  }

  editVehicle(data) :any {
    this.snackBar.openFromComponent(SuccesSnakBarComponent, {
      duration: 3000,
    });
    return this.http.put(`${this.uri}/api/vehicles/${data.id}`, data);
  }

  //Form
  initForm() :any {
    const form: UntypedFormGroup = new UntypedFormGroup({
      type: new UntypedFormControl(null),
      nom: new UntypedFormControl(null),
    });

    this.form = form;
  }

  //pass in a candidate and populate it with it's fields
  createForm(vehicle) :any {
    const form = new UntypedFormGroup({
      type: new UntypedFormControl(vehicle.type),
      nom: new UntypedFormControl(vehicle.nom),
    });
    this.form = form;
  }

  getVehicle(id) :any {
    return this.http.get(`${this.uri}/api/vehicles/${id}`);
  }

  public form: UntypedFormGroup = new UntypedFormGroup({
    type: new UntypedFormControl(null),
    nom: new UntypedFormControl(null),
  });
}
